<template>
  <div>
    <!-- Hero -->
    <div class="bg-body-light">
      <div class="content content-full">
        <div class="d-flex flex-column flex-sm-row justify-content-sm-between align-items-sm-center py-2 text-center text-sm-left">
          <div class="flex-sm-fill">
            <h1 class="h3 font-w700 mb-2">
              Dashboard
            </h1>
          </div>
        </div>
      </div>
    </div>
    <!-- END Hero -->

    <!-- Page Content -->
    <div class="content">
      <!-- Stats -->
      <b-row>
      <!--  <b-col cols="6" md="3" lg="6" xl="3">
          <base-block tag="a" rounded link-pop content-class="d-flex py-4" href="javascript:void(0)">
            <div class="flex-grow-1">
              <router-link
                    :to="{ name: 'Tables User'}"
                  >
              <div class="font-size-sm font-w600 text-uppercase text-muted">
               Users                   
              </div>
              <div class="font-size-h3">
                {{users}}
              </div>
            </router-link>
            </div>
            <div class="d-flex ml-2">
              <div class="flex-grow-1 px-1 bg-success-light rounded-lg"></div>
            </div>
          </base-block>
        </b-col>
        <b-col cols="6" md="3" lg="6" xl="3">
          <base-block tag="a" rounded link-pop content-class="d-flex py-4" href="javascript:void(0)">
            <div class="flex-grow-1">
              <router-link
                    :to="{ name: 'Subscriptions'}"
                  >
              <div class="font-size-sm font-w600 text-uppercase text-muted">
                Subscriptions
              </div>
              <div class="font-size-h3">
                {{ subscriptions }}
              </div>
            </router-link>
            </div>
            <div class="d-flex ml-2">
              <div class="flex-grow-1 px-1 bg-danger-light rounded-lg"></div>
            </div>
          </base-block>
        </b-col> 
        <b-col cols="6" md="3" lg="6" xl="3">
          <base-block tag="a" rounded link-pop content-class="d-flex py-4" href="javascript:void(0)">
            <div class="flex-grow-1">
              <router-link
                    :to="{ name: 'Colleges'}"
                  >
              <div class="font-size-sm font-w600 text-uppercase text-muted">
                Colleges
              </div>
              <div class="font-size-h3">
                {{ colleges }}
              </div>
            </router-link>
            </div>
            <div class="d-flex ml-2">
              <div class="flex-grow-1 px-1 bg-success-light rounded-lg"></div>
            </div>
          </base-block>
        </b-col>
        <b-col cols="6" md="3" lg="6" xl="3">
          <base-block tag="a" rounded link-pop content-class="d-flex py-4" href="javascript:void(0)">
            <div class="flex-grow-1">
              <router-link
                    :to="{ name: 'Tables Questions'}"
                  >
              <div class="font-size-sm font-w600 text-uppercase text-muted">
                Questions
              </div>
              <div class="font-size-h3">
                {{ questions }}
              </div>
            </router-link>
            </div>
            <div class="d-flex ml-2">
              <div class="flex-grow-1 px-1 bg-danger-light rounded-lg"></div>
            </div>
          </base-block>
        </b-col> 
         <b-col cols="6" md="3" lg="6" xl="3">
          <base-block tag="a" rounded link-pop content-class="d-flex py-4" href="javascript:void(0)">
            <div class="flex-grow-1">
              <router-link
                    :to="{ name: 'All India Mock Test'}"
                  >
              <div class="font-size-sm font-w600 text-uppercase text-muted">
                All India Mock Tests
              </div>
              <div class="font-size-h3">
                {{ allindiatests }}
              </div>
            </router-link>
            </div>
            <div class="d-flex ml-2">
              <div class="flex-grow-1 px-1 bg-success-light rounded-lg"></div>
            </div>
          </base-block>
        </b-col> -->
        </b-row>
        
        <b-row>
      <!--  <b-col cols="6" md="3" lg="6" xl="3">
          <base-block tag="a" rounded link-pop content-class="d-flex py-4" href="javascript:void(0)">
            <div class="flex-grow-1">
               <router-link
                    :to="{ name: 'Recruitment Drive Test'}"
                  >
              <div class="font-size-sm font-w600 text-uppercase text-muted">
                Recritment Drives
              </div>
              <div class="font-size-h3">
                {{ recruitments }}
              </div>
            </router-link>
            </div>
            <div class="d-flex ml-2">
              <div class="flex-grow-1 px-1 bg-danger-light rounded-lg"></div>
            </div>
          </base-block>
        </b-col>
        <b-col cols="6" md="3" lg="6" xl="3">
          <base-block tag="a" rounded link-pop content-class="d-flex py-4" href="javascript:void(0)">
            <div class="flex-grow-1">
              <router-link
                    :to="{ name: 'Upcomming Drives'}"
                  >
              <div class="font-size-sm font-w600 text-uppercase text-muted">
                Upcoming Drives
              </div>
              <div class="font-size-h3">
                {{ upcommings }}
              </div>
            </router-link>
            </div>
            <div class="d-flex ml-2">
              <div class="flex-grow-1 px-1 bg-success-light rounded-lg"></div>
            </div>
          </base-block>
        </b-col> -->
          <b-col cols="6" md="3" lg="6" xl="3">
          <base-block tag="a" rounded link-pop content-class="d-flex py-4" href="javascript:void(0)">
            <div class="flex-grow-1">
              <router-link
                    :to="{ name: 'Chats'}"
                  >
              <div class="font-size-sm font-w600 text-uppercase text-muted">
                Chats
              </div>
              <div class="font-size-h3">
                {{ chats }}
              </div>
            </router-link>
            </div>
            <div class="d-flex ml-2">
              <div class="flex-grow-1 px-1 bg-success-light rounded-lg"></div>
            </div>
          </base-block>
        </b-col>
          <b-col cols="6" md="3" lg="6" xl="3">
          <base-block tag="a" rounded link-pop content-class="d-flex py-4" href="javascript:void(0)">
            <div class="flex-grow-1">
              <router-link
                    :to="{ name: 'Help'}"
                  >
              <div class="font-size-sm font-w600 text-uppercase text-muted">
                Helps
              </div>
              <div class="font-size-h3">
                {{ helps }}
              </div>
            </router-link>
            </div>
            <div class="d-flex ml-2">
              <div class="flex-grow-1 px-1 bg-success-light rounded-lg"></div>
            </div>
          </base-block>
        </b-col>
          <b-col cols="6" md="3" lg="6" xl="3">
          <base-block tag="a" rounded link-pop content-class="d-flex py-4" href="javascript:void(0)">
            <div class="flex-grow-1">
              <router-link
                    :to="{ name: 'Discussions'}"
                  >
              <div class="font-size-sm font-w600 text-uppercase text-muted">
                Discussions
              </div>
              <div class="font-size-h3">
                {{ discussions }}
              </div>
            </router-link>
            </div>
            <div class="d-flex ml-2">
              <div class="flex-grow-1 px-1 bg-success-light rounded-lg"></div>
            </div>
          </base-block>
        </b-col>
          <b-col cols="6" md="3" lg="6" xl="3">
          <base-block tag="a" rounded link-pop content-class="d-flex py-4" href="javascript:void(0)">
            <div class="flex-grow-1">
              <router-link
                    :to="{ name: 'Feedbacks'}"
                  >
              <div class="font-size-sm font-w600 text-uppercase text-muted">
                Feedbacks
              </div>
              <div class="font-size-h3">
                {{ feed_backs }}
              </div>
            </router-link>
            </div>
            <div class="d-flex ml-2">
              <div class="flex-grow-1 px-1 bg-success-light rounded-lg"></div>
            </div>
          </base-block>
        </b-col>
          <b-col cols="6" md="3" lg="6" xl="3">
          <base-block tag="a" rounded link-pop content-class="d-flex py-4" href="javascript:void(0)">
            <div class="flex-grow-1">
              <router-link
                    :to="{ name: 'All Test Reports'}"
                  >
              <div class="font-size-sm font-w600 text-uppercase text-muted">
                Test Reports
              </div>
              <div class="font-size-h3">
              </div>
            </router-link>
            </div>
            <div class="d-flex ml-2">
              <div class="flex-grow-1 px-1 bg-success-light rounded-lg"></div>
            </div>
          </base-block>
        </b-col>
      </b-row>
      <!-- END Stats -->
    </div>
    <!-- END Page Content -->
  </div>
</template>

<script>
import axios from "axios";
export default {
  data() {
    return {
      users: "",
      subscriptions:"",
      colleges:"",
      questions:"",
      allindiatests:"",
      recruitments: "",
      upcommings: "",

      chats:"",
      helps:"",
      discussions:"",
      feed_backs:"",
    };
  },
  mounted() {
    this.getUsers();
    this.getSubscriptions();
    this.getColleges();
    this.getQuestions();
    this.getallindiatests();
    this.getRecruitmentDrives();
    this.getupcommingDrives();
     this.getDashboard();
  },
  methods: {
    async getDashboard() {
      await axios
        .get(`${this.$store.getters.baseUrl}/dashboard`, {
          headers: { Authorization: `Bearer ${this.$store.getters.token}` },
        })
        .then((response) => {
          console.log(response);
          if (response.data.status == "success") {
            this.chats = response.data.chats;
            this.helps = response.data.helps;
            this.discussions = response.data.discussions;
            this.feed_backs = response.data.feed_backs;
          } else {
            this.$swal("Error", response.data.message, "warning");
          }
        })
        .catch((error) => {
          console.log(error);
          this.$swal("Error", error.response.data.message, "error");
        });
    },
    async getUsers() {
      await axios
        .get(`${this.$store.getters.baseUrl}/user_count`, {
          headers: { Authorization: `Bearer ${this.$store.getters.token}` },
        })
        .then((response) => {
          console.log(response);
          if (response.data.status == "success") {
            this.users = response.data.users;
          } else {
            this.$swal("Error", response.data.message, "warning");
          }
        })
        .catch((error) => {
          console.log(error);
          this.$swal("Error", error.response.data.message, "error");
        });
    },
     async getSubscriptions(){
      await axios
        .get(`${this.$store.getters.baseUrl}/subscription_count`, {
          headers: {
            Authorization: `Bearer ${this.$store.getters.token}`,
          },
        })
        .then((response) => {
          console.log(response);
          if (response.data.status == "success") {
            this.subscriptions = response.data.subscriptions;
          } else {
            this.$swal("Error", response.data.message, "warning");
          }
        })
        .catch((error) => {
          console.log(error);
          this.$swal("Error", error.response.data.message, "error");
        });
    },
     async getColleges() {
      await axios
        .get(`${this.$store.getters.baseUrl}/college_count`, {
          headers: {
            Authorization: `Bearer ${this.$store.getters.token}`,
          },
        })
        .then((response) => {
          console.log(response);
          if (response.data.status == "success") {
            this.colleges = response.data.colleges;
          } else {
            this.$swal("Error", response.data.message, "warning");
          }
        })
        .catch((error) => {
          console.log(error);
          this.$swal("Error", error.response.data.message, "error");
        });
    },
    async getQuestions() {
      await axios
        .get(`${this.$store.getters.baseUrl}/questions/count`, {
          headers: {
            Authorization: `Bearer ${this.$store.getters.token}`,
          },
        })
        .then((response) => {
          console.log(response);
          if (response.data.status == "success") {
            this.questions = response.data.question_count.length;
          } else {
            this.$swal("Error", response.data.message, "warning");
          }
        })
        .catch((error) => {
          console.log(error);
          this.$swal("Error", error.response.data.message, "error");
        });
    },
     async getallindiatests(){
      await axios
        .get(`${this.$store.getters.baseUrl}/all-India-mock-test_count`, {
          headers: {
            Authorization: `Bearer ${this.$store.getters.token}`,
          },
        })
        .then((response) => {
          console.log(response);
          if (response.data.status == "success") {
            this.allindiatests = response.data.all_india_mock_tests;
          } else {
            this.$swal("Error", response.data.message, "warning");
          }
        })
        .catch((error) => {
          console.log(error);
          this.$swal("Error", error.response.data.message, "error");
        });
    },
     async getRecruitmentDrives() {
      const formdata = new FormData();
      formdata.append("type", "ongoing");
      await axios
        .post(`${this.$store.getters.baseUrl}/recruitment-drive_count`, formdata, {
          headers: { Authorization: `Bearer ${this.$store.getters.token}` },
        })
        .then((response) => {
          console.log(response);
          if(response.data.status == "success") {
          this.recruitments = response.data.recruitment_drives;
          } else {
            this.$swal("Error", response.data.message, "warning");
          }
        })
        .catch((error) => {
          console.log(error);
          this.$swal("Error", error.response.data.message, "error");
        });
    },
    async getupcommingDrives() {
      const formdata = new FormData();
      formdata.append("type", "upcoming");
      await axios
        .post(`${this.$store.getters.baseUrl}/recruitment-drive_count`, formdata, {
          headers: {
            Authorization: `Bearer ${this.$store.getters.token}`,
          },
        })
        .then((response) => {
          console.log(response);
          if (response.data.status == "success") {
            this.upcommings = response.data.recruitment_drives;
          } else {
            this.$swal("Error", response.data.message, "warning");
          }
        })
        .catch((error) => {
          console.log(error);
          this.$swal("Error", error.response.data.message, "error");
        });
    },
  }
}
</script>
